interface AnchorNavItem {
  icon: string;
  label: string;
  href: string;
}

interface AnchorNavProps {
  items: AnchorNavItem[];
  accentColor?: string;
}

export default function AnchorNav({ items, accentColor = 'text-primary' }: AnchorNavProps) {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="bg-white border-b border-gray-100 sticky top-20 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center overflow-x-auto scrollbar-hide">
          {items.map((item, idx) => (
            <button
              key={idx}
              onClick={() => handleClick(item.href)}
              className={`flex items-center gap-2 px-5 py-4 text-xs font-medium whitespace-nowrap border-b-2 border-transparent hover:border-current transition-all duration-200 cursor-pointer flex-shrink-0 ${accentColor} hover:bg-gray-50`}
            >
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-sm`}></i>
              </div>
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
